/**
 * Week prev/next controls for the meal planner (Plan tab only).
 * Compact enclosed segment: week label + joined arrows (Design A).
 */
export default function WeekNavigationBar({
  weekLabel,
  canGoPrevious = false,
  canGoNext = false,
  onPreviousWeek,
  onNextWeek,
  loading = false,
}) {
  return (
    <nav className="planner-week-nav" aria-label="Meal plan week">
      <div className="planner-week-nav-label" aria-live="polite">
        {weekLabel}
      </div>

      <div className="planner-week-nav-arrows">
        <button
          type="button"
          className="planner-week-nav-arrow"
          onClick={onPreviousWeek}
          disabled={!canGoPrevious || loading}
          aria-label="Previous week"
        >
          <span aria-hidden="true">‹</span>
        </button>
        <button
          type="button"
          className="planner-week-nav-arrow"
          onClick={onNextWeek}
          disabled={!canGoNext || loading}
          aria-label="Next week"
        >
          <span aria-hidden="true">›</span>
        </button>
      </div>
    </nav>
  )
}
